<template>
  <div>
    <v-list-item @click="dialog = true">
      <v-list-item-content>
        <v-list-item-title>
          <v-icon :color="kindIconColor">{{ kindIcon }}</v-icon>
          {{ kindDisplay }} -
          {{ createdDisplay }}
        </v-list-item-title>
        <v-list-item-title v-html=""></v-list-item-title>
        <v-list-item-title v-if="status.comment" v-html="status.comment"></v-list-item-title>
      </v-list-item-content>
    </v-list-item>
    <v-dialog v-model="dialog" max-width="500">
      <v-card>
        <v-card-title class="text-h5 text-center">
          <v-icon :color="kindIconColor">{{ kindIcon }}</v-icon> {{ kindDisplay }} -
          {{ createdDisplay }}</v-card-title
        >
        <v-card-text>{{ status.comment }}</v-card-text>
      </v-card></v-dialog
    >
  </div>
</template>

<script>
import { getStatusDisplay, getStatusIcon, getStatusIconColor } from '@/api/status'

export default {
  name: 'StatusListItem',
  props: {
    status: {
      type: Object,
      default: () => {
        return { kind: 0, comment: '' }
      },
    },
  },
  data() {
    return {
      dialog: false,
    }
  },
  computed: {
    createdDisplay() {
      return this.$moment(this.status.created_at).format('LLL')
    },
    kindDisplay() {
      return getStatusDisplay(this.status.kind)
    },
    kindIcon() {
      return getStatusIcon(this.status.kind)
    },
    kindIconColor() {
      return getStatusIconColor(this.status.kind)
    },
  },
}
</script>
